import { render, staticRenderFns } from "./pedidosDetalle.vue?vue&type=template&id=77db58a7"
import script from "./pedidosDetalle.vue?vue&type=script&lang=js"
export * from "./pedidosDetalle.vue?vue&type=script&lang=js"
import style0 from "./pedidosDetalle.vue?vue&type=style&index=0&id=77db58a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports